import PopupControl from 'modules/stream/ui/components/full-size-control-panel/popupControl';
import useInitOverlay from '../hooks/initializers/use-init-overlay';
import UDText from '../../../ud-ui/components/text';
import { FullSizeControlPanelWrapper, TimeAndBoards } from './styles';
import Dashboard from 'modules/stream/ui/components/full-size-control-panel/dashboard';
import TeamPanel from 'modules/stream/ui/components/full-size-control-panel/team-panel';
import Period from 'modules/stream/ui/components/full-size-control-panel/period';
import { useQueryParam } from 'use-query-params';
import SyncStateButton from 'modules/stream/ui/components/full-size-control-panel/syncStateButton';
import ConnectionIndicator from 'modules/stream/ui/components/full-size-control-panel/connectionIndicator';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';

function FullSizeControlPanel() {
  useInitOverlay();

  const boardId = Number(useQueryParam('boardId')[0]);

  const { data: feature, isFetching: isFeatureFetching } = useFetchAvailableFeature();

  if (!isFeatureFetching && !feature?.OBS_INTEGRATION) {
    return (
      <UDText className={'flex-center w-100 h-100'} type={'headline'}>
        Нет доступа. Необходима подписку, обратитесь в поддержку.
      </UDText>
    );
  }

  return (
    <FullSizeControlPanelWrapper>
      <div className={'flex-row gap-4'}>
        {!boardId && <PopupControl />}
        <SyncStateButton />
        <ConnectionIndicator />
      </div>
      <TimeAndBoards className={'mt-4 gap-8'}>
        <Period className={'flex-wrap'} style={{ maxWidth: 270 }} />
        <Dashboard boardId={isNaN(boardId) ? undefined : boardId} className={'flex-wrap'} />
      </TimeAndBoards>
      <div className="mt-4 flex-wrap gap-8">
        <TeamPanel className="flex-grow-1" teamIndex={0} />
        <TeamPanel className="flex-grow-1" teamIndex={1} />
      </div>
    </FullSizeControlPanelWrapper>
  );
}

export default FullSizeControlPanel;
